import { Component } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';

declare var $: any;
declare var Site: any;

@Component({
  selector: 'app-admin-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css']
})
export class AppAdminComponent {
  title = 'app';
  constructor(private translate: TranslateService, private titleService: Title) {
    translate.setDefaultLang('vi');
    let lang = localStorage.getItem('lang') || 'vi';
    translate.use(lang);

    this.translate.onLangChange.subscribe(() => {
      this.updateTitle();
    });
    this.updateTitle();

    $(document).ready(function ($) {
      Site.run();
    });
  }

  updateTitle() {
    this.titleService.setTitle(this.translate.instant('APP_TITLE'));
  }
}



// WEBPACK FOOTER //
// /app/src/app/app-admin.component.ts